
import {  useEffect, React }  from 'react';
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderGuest from "../../components/layout/HeaderGuest";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";

import FirstTimeRegistration from "../../components/seller-registration/FirstTimeRegistration";
import CounterSection from "../../components/seller-registration/CounterSection";
import Steps from "../../components/seller-registration/StepsRegistration";



const SellerRegistration = () => {
    useEffect(() => {
        document.title = "iWant Seller Registration";
    }, []);

  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#990A02' />

      {/* Preloader */}
      <Preloader />

    <HeaderGuest />
      
    <FirstTimeRegistration />

    <Steps />

    <CounterSection />


      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default SellerRegistration;